import AbstractListResource from './abstract/abstract-list-resource';
import Subscription from './items/subscription';
import {Resource, ActionType, SubscriptionStatus}  from 'sdk/src/defines';
import {TFunction} from 'react-i18next';
import {DropDownItem} from '../utility/types';
import {AttributesType} from '../utility/types';

class Subscriptions extends AbstractListResource<Subscription> {
    public resourceType: Resource = Resource.SUBSCRIPTIONS;

    public resourceItemClass: typeof Subscription = Subscription;

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.UPDATE,
        ActionType.CREATE,
    ];

    public static statusesForDropDown(t: TFunction, empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: null,
            });
        }

        result.push(
            {
                label: t('subscriptions.active'),
                value: SubscriptionStatus.ACTIVE,
            },
            {
                label: t('subscriptions.expired'),
                value: SubscriptionStatus.EXPIRED,
            },
            {
                label: t('subscriptions.canceled'),
                value: SubscriptionStatus.CANCELLED,
            },
            {
                label: t('subscriptions.trialing'),
                value: SubscriptionStatus.TRIALING,
            },
            {
                label: t('subscriptions.renewed'),
                value: 'renewed',
            },
        );

        return result;
    }
    public export(params?: AttributesType): Promise<any> {
        return this.api().resourceExport(this.resourceType, params);
    }
}

export {Subscriptions, Subscription};

export default new Subscriptions();
